<template>
  <main class="pt-12 lg:pt-32">
    <h1 class="my-16 text-center text-5xl leading-tight text-white md:text-7xl md:leading-tight">Legal</h1>
    <Container>
      <section class="grid gap-10 text-white lg:grid-cols-2">
        <div
          v-for="(term, index) in terms"
          :key="index">
          <h2 class="mb-2 text-2xl font-medium leading-[1.2]">
            {{ term.title }}
          </h2>
          <p>{{ term.description }}</p>
          <NuxtLink
            :href="term.link"
            class="block font-bold underline">
            {{ term.label }}
          </NuxtLink>
        </div>
      </section>
    </Container>
  </main>
</template>

<script setup lang="ts">
  import terms from '@/assets/data/legal.json'

  const TITLE = 'Legal Information | Outfit7 – Makers of Talking Tom & Friends'
  const DESCRIPTION =
    'Learn about Outfit7’s privacy policy, terms of service, and user rights. We create safe, family-friendly mobile games loved worldwide, including the Talking Tom & Friends series.'

  const route = useRoute()
  const { cdnUrl } = useRuntimeConfig().public

  useHead({
    title: TITLE,
    link: [
      {
        rel: 'canonical',
        href: `https://outfit7.com${route.path}`
      }
    ],
    meta: [
      { hid: 'description', name: 'description', content: DESCRIPTION },
      { hid: 'og:title', property: 'og:title', content: TITLE },
      { hid: 'og:description', property: 'og:description', content: DESCRIPTION },
      {
        hid: 'og:image',
        property: 'og:image',
        content: `${cdnUrl}/assets/2_our_story/2_0_this_is_us/this_is_us_below_header.jpg`
      },
      { hid: 'twitter:title', name: 'twitter:title', content: TITLE },
      { hid: 'twitter:description', name: 'twitter:description', content: DESCRIPTION },
      {
        hid: 'twitter:image',
        name: 'twitter:image',
        content: `${cdnUrl}/assets/2_our_story/2_0_this_is_us/this_is_us_below_header.jpg`
      }
    ]
  })
</script>
